import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { AngaMark } from "@/components/brand/AngaMark";
import { LocationGate } from "@/components/location/LocationGate";
import { usePlatformConfig } from "@/lib/config";

export const Route = createFileRoute("/app/location-gate")({
  validateSearch: (search: Record<string, unknown>) => {
    const edit = search["edit"];
    return edit === "1" || edit === 1 || edit === true ? { edit: "1" as const } : {};
  },
  head: () => ({
    meta: [
      { title: "Set your place" },
      { name: "description", content: "Save a ward and county before using Meteo." },
    ],
  }),
  component: LocationGatePage,
});

function LocationGatePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { platformName } = usePlatformConfig();
  const search = Route.useSearch();
  const editing = search.edit === "1";

  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--primary-soft),_transparent_50%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-lg flex-col px-5 py-6">
        <header className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#064E3B] text-white">
            <AngaMark className="h-6 w-6" title={platformName} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate font-display text-lg font-bold leading-none">{platformName}</p>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.16em] text-muted-foreground">
              Location gate
            </p>
          </div>
        </header>
        <LocationGate
          editing={editing}
          onComplete={() => {
            void queryClient.invalidateQueries({ queryKey: ["user"] });
            void queryClient.invalidateQueries({ queryKey: ["user", "places", "gate"] });
            void navigate({ to: "/app/" });
          }}
        />
      </div>
    </div>
  );
}
